export default function declinationByNumber(number: number | string, words: string): string {
  const wordsArray = words.split('|').map((el) => el.trim());
  const remainderDividedByHundred = Math.abs(Number(number)) % 100;
  const remainderDividedByTen = remainderDividedByHundred % 10;
  if (remainderDividedByHundred > 10 && remainderDividedByHundred < 20) { return wordsArray[2]; }
  if (remainderDividedByTen > 1 && remainderDividedByTen < 5) { return wordsArray[1]; }
  if (remainderDividedByTen === 1) { return wordsArray[0]; }
  return wordsArray[2];
}
